import React from 'react';

const ChangePassword = () => {
    return (
        <div>
            <h1>This is Change Password</h1>
        </div>
    );
};

export default ChangePassword;